"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSummaryStore = void 0;
var services_1 = require("../services");
var index_1 = require("./index");
var TagSummaryStore = /** @class */ (function () {
    function TagSummaryStore() {
    }
    TagSummaryStore.prototype.getFetchable = function (tagId) {
        var rest = services_1.Services.Department.rest;
        var tag = index_1.AppStore.Tag.get(tagId);
        if (tag == null) {
            services_1.Services.Log.Logger.warn({ tagId: tagId }, 'Getting tag summary before tag');
            return rest.empty;
        }
        var fetchable = rest.Tag.Summary.getById(tag.objectId);
        if (fetchable.isFetching) {
            return fetchable;
        }
        if (fetchable.value == null) {
            return fetchable;
        }
        var fetchTime = Date.now() - fetchable.lastFetch;
        if (fetchTime < TagSummaryStore.REFETCH_DELAY) {
            return fetchable;
        }
        var tagUpdated = services_1.Services.DateTime.getTime(tag.updatedAt);
        if (tagUpdated < fetchable.lastFetch) {
            return fetchable;
        }
        // Looks like the tag summary is out of date force a refetch
        fetchable.refetch();
        return fetchable;
    };
    TagSummaryStore.prototype.get = function (tagId) {
        return index_1.AppStore.TagSummary.getFetchable(tagId).value;
    };
    TagSummaryStore.prototype.clear = function () {
        var rest = services_1.Services.Department.rest;
        if (rest != null) {
            rest.cache.clear(rest.Objects.TagSummary);
        }
    };
    // Only refetch tag summaries at most once per 10 seconds.
    TagSummaryStore.REFETCH_DELAY = 10000;
    return TagSummaryStore;
}());
exports.TagSummaryStore = TagSummaryStore;
//# sourceMappingURL=tag.summary.store.js.map